"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraLongStringSchema = exports.LongStringSchema = exports.MediumStringSchema = exports.ShortStringSchema = exports.ShortestStringSchema = void 0;
const zod_1 = require("zod");
exports.ShortestStringSchema = zod_1.z.string().max(128);
exports.ShortStringSchema = zod_1.z.string().max(256);
exports.MediumStringSchema = zod_1.z.string().max(1024);
exports.LongStringSchema = zod_1.z.string().max(2048);
exports.ExtraLongStringSchema = zod_1.z.string().max(10000);
//# sourceMappingURL=strings.js.map